import { render, staticRenderFns } from "./WasteGenerationBySource.vue?vue&type=template&id=00189d3c&"
import script from "./WasteGenerationBySource.vue?vue&type=script&lang=js&"
export * from "./WasteGenerationBySource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports